<template>
  <v-dialog v-model="dialogStatus"
            persistent
            max-width="800px">
    <div class="fill-height">


      <v-card class="fill-height">

        <v-card-subtitle>ارسال/ویرایش پیام</v-card-subtitle>
        <v-spacer/>

        <v-card-text>


          <v-form  ref="form" @submit.prevent="save" lazy-validation v-model="valid">
            <v-row>
              <v-col
                  cols="12"
                  sm="6"

                  >
                <v-autocomplete
                    :items="modelItems.buildingList"
                    v-model="modelItems.model.buildingId"
                    @input="handleInput"
                    dense
                    outlined
                    @change="getUserList"
                    :error-messages="getError('buildingId')"
                    auto-select-first  append-icon="fas fa-angle-down"
                    label="انتخاب مجتمع"

                />
              </v-col>
              <v-col cols="12" sm="6"  >

                <v-autocomplete
                    :items="unitList"
                    v-model="modelItems.model.userIds"
                    outlined
                    dense
                    chips
                    :error-messages="getError('userIds')"
                    small-chips
                    label="انتخاب کاربرها"
                    multiple
                >
                  <template v-slot:prepend-item>
                    <v-checkbox
                        v-model="selectAll"
                        label="انتخاب همه "
                        @click="select_All_User()"
                    />
                  </template>


                  <template v-slot:selection="{ item, index }">
<!--                    <v-chip v-if="index === 0">-->
                      <span v-if="index === 0" >{{ item.text }}</span>
<!--                    </v-chip>-->
                    <span
                        v-if="index === 1"
                        class="grey--text caption"
                    >
          (+{{ modelItems.model.userIds.length - 1 }} دیگر)
        </span>
                  </template>


                </v-autocomplete>

              </v-col>
              <v-col cols="12" sm="12">
                <v-text-field
                    label="عنوان پیام"
                    outlined
                    dense
                    :error-messages="getError('title')"
                    v-model="modelItems.model.title"
                />
              </v-col>
              <v-col cols="12"
                     md="12"
              >

                <v-textarea
                    label="متن پیام"
                    outlined
                    dense
                    :error-messages="getError('text')"
                    v-model="modelItems.model.text"
                />

              </v-col>



            </v-row>


            <v-divider class="p-0 m-0"/>
            <v-card-actions dir="ltr">

              <v-btn
                 small
                 depressed
                  color="primary"
                  class=" p-1 m-1"
                  type="submit"
                 :loading="loading"
              >
                ارسال پیام
              </v-btn>
              <v-btn
                 small
                 depressed
                  color="error"
                  class=" p-1 m-1"
                  @click="closed"
              >
                لغو
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
import Message_se from "./Message_se";



export default {

  props: {
    dialogStatus: {
      default: false,
    },
    modelItems: Object,
    buildingId: String,
    unitList: Array,
  },
  data() {
    return {
      currentUser:{},
      bindingErrors: [],
      items: [],
      selectUserId: [],
      valid: true,
      selectAll: false,
      loading: false,

    }
  },
  // mounted() {
  //   this.$root.$on('MessageEdit', () => {
  //      // this.getUserList()
  //   })
  // },
  // computed:{
  //   listUser() {
  //     // this.getUserList(this.buildingId)
  //     return this.unitList;
  //   }
  // },
  methods: {

    handleInput (value) {
      this.$emit('input', value)
    },


    getUserList(val){
      Message_se.getUser(val).then(response=>{
        return this.unitList=response.data;
      })
    },

    select_All_User(){
      this.modelItems.model.userIds = [];
      if (this.selectAll) {
        for (let item in this.unitList) {
          this.modelItems.model.userIds.push(this.unitList[item].value);
        }
      }
    },

    getError(key) {
      if (this.bindingErrors && this.bindingErrors.length > 0) {
        let error = this.bindingErrors.find( ({ fieldName }) => fieldName === key );
        if(error && error.message ) return  error.message[0]
      }
      return ''
    },
    closed() {
      this.bindingErrors=[]
      this.unitList=[]
      this.selectUserId=[]
      this.loading=false
      this.$emit('update:dialogStatus', false)
      this.$root.$emit('Message')
    },

    save(){
      this.loading=true
      this.bindingErrors = []
      this.$progress({message: 'درحال ارسال پیام...'}, true)
        Message_se.save(this.modelItems.model).then(response => {
          if (response && response.status === 200) {
            this.$root.$emit('Progress')
            this.$snack({type: 'success'})
            this.unitList=[]
            this.selectUserId=[]
            this.$root.$emit('RequestUser')
            this.$root.$emit('UpdateMessage')
            this.closed()
          }else if (response && response.response.status === 400) {
            this.loading=false
            this.$root.$emit('Progress')
            this.bindingErrors = response.response.data;
          }
        })


    },

  },

}
</script>


